import { BiographySection } from './components/BiographySection';
import { TopInsightsSection } from './components/TopInsightsSection';
import { PersonaDetailsSection } from './components/PersonaDetailsSection';
import { MediaConsumptionSection } from './components/MediaConsumptionSection';
import { CaresAboutSection } from './components/CaresAboutSection';
import { DidYouKnowSection } from './components/DidYouKnowSection';
import type { PersonaDetailV2Props } from './PersonaDetailV2.types';

export const PersonaDetailV2 = ({ persona, compact, action, exporting }: PersonaDetailV2Props) => {
  return (
    // The IQ report's rhythm between blocks: 40px, rule, 40px. The rule rides on
    // each section that has one before it rather than standing between them as its
    // own element, because five of these six render nothing when the persona
    // carries no data for them - a separator of its own would be left stranded
    // above or below the gap it was meant to fill.
    <div className="mx-auto flex max-w-[1080px] flex-col justify-self-center gap-10 p-5 [&>*~*]:border-t [&>*~*]:border-border-lighter [&>*~*]:pt-10">
      <BiographySection
        persona={persona}
        compact={compact}
        action={exporting ? undefined : action}
      />
      <TopInsightsSection persona={persona} />
      <PersonaDetailsSection persona={persona} />
      <MediaConsumptionSection persona={persona} exporting={exporting} />
      <CaresAboutSection persona={persona} />
      <DidYouKnowSection persona={persona} />
    </div>
  );
};
